import { render, staticRenderFns } from "./ExternalShareAction.vue?vue&type=template&id=0f0e27d0&"
import script from "./ExternalShareAction.vue?vue&type=script&lang=js&"
export * from "./ExternalShareAction.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports